import { create } from "zustand";

import { MeilisearchAction, MeilisearchState } from "./props";

export const useMeilisearchStore = create<MeilisearchState & MeilisearchAction>(
  (set) => ({
    query: "",

    setQuery(query) {
      set({
        query,
      });
    },
  })
);
